var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"title"},[_vm._v("产品文档")]),_c('markdown',{attrs:{"value":_vm.proDetail&&_vm.proDetail.userDocumentationH}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }